export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const footerLinks = [
    { label: '最新动态', href: '#updates' },
    { label: '热播榜单', href: '#ranking' },
    { label: '热门话题', href: '#topics' },
    { label: '影视索引', href: '#index' },
    { label: '关于91影视', href: '#about' },
    { label: '联系我们', href: '#contact' },
    { label: '核心优势', href: '#features' },
    { label: '精选专题', href: '#carousel' },
    { label: '精彩集锦', href: '#media' },
    { label: 'APP下载', href: '#app' },
    { label: '影视资讯', href: '#cards' },
    { label: '常见问题', href: '#faq' },
  ];

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="section-container py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="font-display text-xl text-background-50 mb-3">91影视看片app</div>
            <p className="text-sm text-background-400 leading-relaxed">
              91影视看片app汇聚高清电影在线观看、蓝光影视资源、高清电视剧免费全集和超清综艺播放内容。
              片源清晰度领先，播放流畅不缓冲，致力于为每一位影视爱好者提供极致的高清观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">快速导航</h4>
            <div className="flex flex-col gap-1.5">
              {footerLinks.slice(0, 6).map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">更多内容</h4>
            <div className="flex flex-col gap-1.5">
              {footerLinks.slice(6).map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              诚挚感谢所有合作伙伴的支持与信赖。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 91影视看片app. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">
              回到顶部 <i className="ri-arrow-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}